import '@/assets/sass/default.scss';
import '@/assets/sass/frontpage.scss';
import globalDirectives from './globalDirectives';
import globalMixins from './globalMixins';
import globalComponents from './globalComponents';
import VueLazyload from 'vue3-lazyload'

export default {
    install(app) {
        app.use(globalDirectives);
        app.use(globalMixins);
        app.use(globalComponents);
        app.use(VueLazyload, {
            observerOptions: {
                rootMargin: '0px',
                threshold: 0.1
            }
        });
    }
}
